import React from 'react';
import { getImageDimensions } from '@sanity/asset-utils';
import { urlForImageWithSize } from '../../image';

const ImageComponent = ({ value, isInline }) => {
  const { width, height } = getImageDimensions(value.asset);

  return (
    <img
      src={urlForImageWithSize(value.asset, 1536) || ''}
      alt={value.alt || ' '}
      loading="lazy"
      style={{
        // Display alongside text if image appears inside a block text span
        display: isInline ? 'inline-block' : 'block',

        // Avoid jumping around with aspect-ratio CSS property
        aspectRatio: width / height,
      }}
      width={width}
      height={height}
    />
  );
};

export default ImageComponent;
